import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@abb/uikit';
import { useColorMode } from '@abb/uikit';
import { mode } from '@abb/uikit';
import { motion } from 'framer-motion';
import React from 'react';
const LogoIcon = ()=>{
    const { colorMode } = useColorMode();
    const color = mode('#2058BB', 'white')({
        colorMode
    });
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            rotate: 0
        },
        animate: {
            rotate: 360
        },
        transition: {
            ease: 'linear',
            duration: 4,
            repeat: Infinity,
            delay: 0.1
        },
        children: /*#__PURE__*/ _jsx(Icon, {
            width: "74px",
            height: "74px",
            viewBox: "0 0 74 74",
            fill: "none",
            children: /*#__PURE__*/ _jsxs("g", {
                transform: "matrix(0.16972479 0 0 0.16972479 0 0)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M81.8523 218C 57.3905 178.444 44.2975 131.64 53.097 84.2206C 56.0989 68.0461 69.0775 55.4805 85.3284 52.9212C 99.8679 50.63 110.378 49.4823 130.972 51.1936C 123.55 63.5149 119.16 75.8036 114.543 87.7467C 104.256 87.3729 93.777 89.4308 90.4579 90.4543C 82.0998 121.348 92.8853 174.24 125.47 218L125.47 218L81.8523 218z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M121.726 121.728C 132.399 76.4605 156.236 34.1063 195.989 6.79851C 209.549 -2.51663 227.612 -2.22342 240.913 7.45688C 252.814 16.118 261.056 22.7387 274.41 38.511C 260.449 41.975 248.654 47.5602 236.944 52.741C 229.935 45.2025 221.071 39.2478 217.999 37.6248C 190.244 53.5596 160.47 98.5886 152.568 152.571L152.568 152.571L121.726 121.728z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M217.997 81.8498C 257.554 57.388 304.356 44.2938 351.776 53.0934C 367.951 56.0952 380.516 69.0739 383.076 85.3247C 385.366 99.8642 386.514 110.374 384.804 130.97C 372.482 123.548 360.194 119.157 348.251 114.539C 348.623 104.254 346.567 93.7744 345.542 90.4553C 314.648 82.0972 261.755 92.8827 217.997 125.467L217.997 125.467L217.997 81.8498z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M314.269 121.726C 359.537 132.4 401.89 156.236 429.198 195.989C 438.514 209.549 438.221 227.611 428.541 240.914C 419.88 252.814 413.259 261.057 397.487 274.41C 394.021 260.45 388.437 248.655 383.257 236.945C 390.795 229.935 396.749 221.071 398.373 218C 382.437 190.244 337.409 160.47 283.427 152.569L283.427 152.569L314.269 121.726z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M354.149 217.996C 378.611 257.553 391.704 304.356 382.904 351.775C 379.903 367.951 366.924 380.515 350.673 383.076C 336.134 385.366 325.624 386.515 305.029 384.802C 312.45 372.482 316.841 360.194 321.459 348.249C 331.745 348.623 342.224 346.565 345.544 345.543C 353.901 314.648 343.116 261.756 310.531 217.996L310.531 217.996L354.149 217.996z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M314.274 314.272C 303.599 359.54 279.763 401.893 240.01 429.2C 226.45 438.517 208.388 438.224 195.086 428.543C 183.186 419.882 174.943 413.261 161.59 397.489C 175.55 394.024 187.344 388.44 199.054 383.259C 206.065 390.796 214.929 396.751 218 398.375C 245.755 382.439 275.53 337.412 283.431 283.429L283.431 283.429L314.274 314.272z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M217.997 354.149C 178.44 378.611 131.637 391.704 84.2179 382.906C 68.0422 379.904 55.4778 366.925 52.9174 350.675C 50.6273 336.135 49.4784 325.624 51.1898 305.03C 63.5122 312.451 75.7998 316.842 87.7429 321.459C 87.3701 331.746 89.4281 342.225 90.4516 345.544C 121.345 353.902 174.238 343.116 217.997 310.531L217.997 310.531L217.997 354.149z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M121.728 314.273C 76.4604 303.6 34.1073 279.764 6.79845 240.01C -2.51669 226.451 -2.22348 208.387 7.4579 195.086C 16.118 183.185 22.7386 174.943 38.512 161.589C 41.976 175.55 47.5601 187.345 52.7409 199.054C 45.2024 206.064 39.2489 214.928 37.6248 218C 53.5595 245.756 98.5885 275.529 152.571 283.43L152.571 283.43L121.728 314.273z",
                        stroke: "none",
                        fill: color,
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
};
export default LogoIcon;
